import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=58eece11&scoped=true&"
import script from "./Description.vue?vue&type=script&lang=js&"
export * from "./Description.vue?vue&type=script&lang=js&"
import style0 from "./Description.vue?vue&type=style&index=0&id=58eece11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eece11",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58eece11')) {
      api.createRecord('58eece11', component.options)
    } else {
      api.reload('58eece11', component.options)
    }
    module.hot.accept("./Description.vue?vue&type=template&id=58eece11&scoped=true&", function () {
      api.rerender('58eece11', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/weeklylogin/campaign/components/Description.vue"
export default component.exports